import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { selectAccountId } from '../../redux/reducers/account/account';
import { accountRoutes } from '../../constants/routes';
import { addLangPrefix } from './buttons/Link';

const STORAGE_KEY = 'whatsNew_v1_seen';
const SHOW_DELAY_MS = 3000;

const NewFeatureIcon = () => (
    <svg
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="currentColor"
        aria-hidden="true"
        style={{ flexShrink: 0 }}
    >
        <path d="M13 2L4.09 12.97a1 1 0 0 0 .78 1.63H10l-1 7.4a1 1 0 0 0 1.82.7L19.91 11a1 1 0 0 0-.78-1.63H14l1-6.68A1 1 0 0 0 13 2z" />
    </svg>
);

export const WhatsNewToast = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const accountId = useSelector(selectAccountId);
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        if (!accountId) return;
        let seen = null;
        try {
            seen = localStorage.getItem(STORAGE_KEY);
        } catch (_) {
            return;
        }
        if (seen) return;

        const timer = setTimeout(() => {
            setVisible(true);
            try {
                localStorage.setItem(STORAGE_KEY, String(Date.now()));
            } catch (_) {}
        }, SHOW_DELAY_MS);

        return () => clearTimeout(timer);
    }, [accountId]);

    if (!visible) return null;

    const close = () => setVisible(false);
    const goCabinet = () => {
        close();
        navigate(addLangPrefix(accountRoutes.CABINET));
    };

    return (
        <div className="whats-new-toast" role="dialog" aria-live="polite">
            <button
                type="button"
                aria-label="close"
                className="whats-new-toast__close"
                onClick={close}
            >
                ×
            </button>
            <div className="whats-new-toast__title">
                <NewFeatureIcon />
                <span>{t('whatsNewTitle')}</span>
            </div>
            <ul className="whats-new-toast__list">
                <li>{t('whatsNewItem1')}</li>
                <li>{t('whatsNewItem2')}</li>
                <li>{t('whatsNewItem3')}</li>
            </ul>
            <button
                type="button"
                className="whats-new-toast__cta"
                onClick={goCabinet}
            >
                {t('whatsNewCta')}
            </button>
        </div>
    );
};
